export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/ads_social_media_videos.fdd2e72.svg";